// @ts-nocheck
import {logEvent} from "@amplitude/analytics-browser";
import PropTypes from "prop-types";
import {BaseButton} from "@/components";
import {DownloadApp} from "../../../config/config";
import colors from "../../../styles/colors";
import {useBrandTitle} from "../../../util/logoUtils";

const InstallationPrompt = ({deviceType, promptEvent, onClose}) => {
  const brandTitle = useBrandTitle();

  const handleInstall = () => {
    if (deviceType === "android") {
      window.open(DownloadApp.ANDROID, "_blank");
      logEvent("install_android_button_clicked");
      onClose();
      return;
    }
    if (promptEvent) {
      promptEvent.prompt();
      logEvent(`install_${deviceType}_button_clicked`);
    }
    onClose();
  };

  return (
    <>
      <h2 style={{textAlign: "center"}}>Instala {brandTitle} App</h2>
      <div style={{textAlign: "center"}}>
        {deviceType === "android" && (
          <p style={{color: colors.WHITE}}>Instala {brandTitle} App en tu dispositivo Android</p>
        )}
        {deviceType === "ios" && <p style={{color: colors.WHITE}}>Instala {brandTitle} App en tu dispositivo iOS</p>}
        {deviceType === "desktop" && <p style={{color: colors.WHITE}}>Instala {brandTitle} App en tu computadora</p>}
        <p style={{color: colors.WHITE}}>AsÃ­ tendrÃ¡s acceso al mejor entretenimiento en tu dispositivo.</p>

        <div style={{marginTop: "1rem", display: "flex", justifyContent: "center", gap: "0.5rem"}}>
          <BaseButton
            variant="primary"
            onClick={handleInstall}
            style={{borderRadius: "var(--radius-sm)"}}
          >
            Instalar
          </BaseButton>
          <BaseButton
            variant="secondary"
            onClick={onClose}
            style={{
              border: `2px solid ${colors.ALTERNATIVE_WHITE}`,
              borderRadius: "var(--radius-sm)",
              color: colors.ALTERNATIVE_WHITE,
              background: "transparent",
            }}
          >
            MÃ¡s tarde
          </BaseButton>
        </div>
      </div>
    </>
  );
};

InstallationPrompt.propTypes = {
  deviceType: PropTypes.string,
  promptEvent: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default InstallationPrompt;
